export default "__VITE_ASSET__6bff18f1__"